import { render } from "./About.vue?vue&type=template&id=4b72ca42&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=4b72ca42&lang=scss&scoped=true"

import exportComponent from "D:\\ideaWorkSpace\\政泉\\zhengquan\\sqlpj-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b72ca42"]])

export default __exports__